import { useSupabaseUser, useSupabaseClient } from '#imports'
import { useRouter } from 'vue-router'

export const useAuthUser = () => {
  const user = useSupabaseUser()
  const client = useSupabaseClient()
  const router = useRouter()
  const { t } = useI18n()

  const isAuthenticated = computed(() => !!user.value)
  const userEmail = computed(() => user.value?.email)
  const userAvatar = computed(() => user.value?.user_metadata?.avatar)

  const logout = async () => {
    try {
      const { error } = await client.auth.signOut()
      if (error) throw error
      await router.push('/login')
    } catch (e) {
      console.error('Chyba při odhlášení:', e)
    }
  }

  return {
    user,
    isAuthenticated,
    userEmail,
    userAvatar,
    logout
  }
}
